'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (params) {
  return Object.keys(params).map(function (k) {
    if (Array.isArray(params[k])) {
      return params[k].map(function (val) {
        return encodeURIComponent(k) + '[]=' + encodeURIComponent(val);
      }).join('&');
    }
    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/fetch/utils/build-query-string.js
// module id = 596
// module chunks = 0